import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TaskSuggestionGroup } from "components/task-suggestions/definitions";
import { IDraftWizardState } from "./definitions";

const initialState: IDraftWizardState = {
  taskData: {},
};

export const draftWizardSlice = createSlice({
  name: "draftWizard",
  initialState,
  reducers: {
    setTaskData: (
      state,
      action: PayloadAction<{
        scanJobId: string;
        taskData: TaskSuggestionGroup[];
      }>
    ) => {
      const { scanJobId, taskData } = action.payload;
      state.taskData[scanJobId] = taskData;
    },
    clearTaskData: (state, action: PayloadAction<{ scanJobId: string }>) => {
      const { scanJobId } = action.payload;
      delete state.taskData[scanJobId];
    },
    clearAllTaskData: (state) => {
      state.taskData = {};
    },
  },
});

export const { setTaskData, clearTaskData, clearAllTaskData } =
  draftWizardSlice.actions;

export default draftWizardSlice.reducer;
